module.exports = __webpack_public_path__ + "static/sport/icon-1.be6ab6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/icon-1.png
// module id = gLT2
// module chunks = 0